// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"73":"35aaa21907dc0aa7","162":"2fe3c0134f8756b3","728":"e2ccfdbdb8e075a2","886":"e3021be883ad126a","996":"0d981137e2008ff0"}[chunkId] + ".js";
};